import React from 'react';
import * as Icons from "react-icons/fa";
import '../../components/styles.css';

export default function BenefitsForPartners() {
    return (
      <div className='container-content-services'
        style={{
          backgroundColor:'gray',
          color:'black',
          border:'20px',
          padding:'20px',
		  	}}
		  >
        <div classNAme='main-content-box-1'  align='center'>
          <p-lg>Benefits For Our Partners</p-lg>
        </div>
        <div className='main-content-box-2'  align='left'>
          <p> <br></br>
          The Athelon Group affiliate marketing program allows businesses to expand their reach, increase 
sales, and tap into new customer segments. 
          </p>
          <p> <br></br>
            • Cost-effective marketing: 
            </p>
            <p> <br></br>
Our affiliate program helps businesses reach a wider audience without the high costs of traditional 
advertising. All that’s required is a partnership — we handle the outreach. 
          </p>
          <p> <br></br>
            • Increased sales and revenue: 
          </p>

          <p> <br></br>
            By leveraging the extensive reach of our program, merchants can drive more sales and grow their 
revenue.
          </p>

         <p> <br></br>
            • Expanded market reach:  
          </p>

          <p> <br></br>
            Access new markets and demographics through our diverse affiliate network, giving your business 
exposure to previously untapped audiences.
          </p>
          
        </div>
        <div className='main-content-box-3' align='center' >
              <p></p>
        </div>
      </div>
    )
  };

